<template>
  <div class="box">
    <el-form :inline="true" :model="formData" ref="topForm" label-width="80px">
      <el-form-item prop="notaryNo" label="卷宗号">
        <el-input size="small" v-model="formData.notaryNo" placeholder="卷宗号" style="width:150px"></el-input>
      </el-form-item>

      <el-form-item prop="dsr" label="当事人">
        <el-input size="small" v-model="formData.dsr" placeholder="当事人" style="width:150px"></el-input>
      </el-form-item>

      <el-form-item prop="status" label="公证状态">
        <el-select size="small" v-model="formData.status" clearable placeholder="请选择" style="width:150px">
          <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="executionType" label="执行状态">
        <el-select size="small" v-model="formData.executionType" clearable placeholder="请选择" style="width:150px">
          <el-option v-for="item in executionTypeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="notarizStatus" label="受理时间" v-if="false">
        <el-date-picker v-model="formData.dateFrame" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" size="small">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="resetForm('topForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import eventVue from "./event.js";
export default {
  data() {
    return {
      // dateFrame:[],
      formData: {
        notaryNo: "", // 卷宗号
        dsr: "", // 当事人
        status: "", // 状态
        dateFrame: null,

      },
      typeOptions: [
        {
          value: 1,
          label: "赋强公证"
        },
        {
          value: 2,
          label: "合同公证"
        },
        {
          value: 10,
          label: "借款合同"
        }
      ],
      stateOptions: [
        {
          value: -2,
          label: "拟定公证书"
        },
        {
          value: -1,
          label: "不予受理"
        },
        {
          value: 1,
          label: "初核"
        },
        {
          value: 2,
          label: "受理"
        },
        {
          value: 3,
          label: "审查"
        },
        {
          value: 4,
          label: "审批"
        },
        {
          value: 5,
          label: "制证"
        },
        {
          value: 6,
          label: "发证"
        },
        {
          value: 7,
          label: "归档"
        },
        {
          value: 8,
          label: "收费"
        }
      ],
      executionTypeOptions:[
      {
          value: 1,
          label: "申请执行"
        },
        {
          value: 2,
          label: "核实中"
        }
      ]
    }
  },
  methods: {
    onSubmit() {
      let temData = {};
      for (let key in this.formData) {
        if (this.formData[key] !== "" && this.formData[key] !== null) {
          temData[key] = this.formData[key];
        }
      }
      if ('dateFrame' in temData) {
        temData.beginDate = temData.dateFrame[0]
        temData.endDate = temData.dateFrame[1]
        delete temData.dateFrame
      }
      if ('issuingTime' in temData) {
        temData.beginIssuingDate = temData.issuingTime[0]
        temData.endIssuingDate = temData.issuingTime[1]
        delete temData.issuingTime
      }


      eventVue.$emit("submit", temData);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      let temData = {};
      for (let key in this.formData) {
        if (this.formData[key] !== "" && this.formData[key] !== null) {
          temData[key] = this.formData[key];
        }
      }
    
      eventVue.$emit("submit", temData);
    },
  }
}
</script>
<style>

</style>